<div cf-loader-spinner-container [showSpinner]="!!(loadingService.loadingState$ | async) || !tentative">
  @if (tentative) {
    <div class="wrapper tentative">
      <div class="card">
        <cf-icon [icon]="tentative.icon" size="xxl"></cf-icon>
        <h3 class="mb-0 mt-3 mx-5">{{ tentative.title }}</h3>
        @if (tentative.description) {
          <cf-text class="mt-3" size="sm" color="grey-70">
            {{ tentative.description }}
          </cf-text>
        }
      </div>

      <footer class="text-center mt-auto mb-3">
        <a routerLink="/" cf-main-logo></a>
      </footer>
    </div>
  }
</div>
